import React from 'react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Brain, Activity, Dumbbell, Gauge, BarChart3 } from 'lucide-react';

export const AnalyticsTabs: React.FC = () => (
  <TabsList className="grid w-full h-auto grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-1" aria-label="Analytics sections">
    <TabsTrigger value="training-intelligence" className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-center text-xs sm:text-sm whitespace-normal">
      <Brain className="h-4 w-4" />
      Training Intelligence
    </TabsTrigger>
    <TabsTrigger value="running" className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-center text-xs sm:text-sm whitespace-normal">
      <Activity className="h-4 w-4" />
      Running Analytics
    </TabsTrigger>
    <TabsTrigger value="fitness" className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-center text-xs sm:text-sm whitespace-normal">
      <Dumbbell className="h-4 w-4" />
      General Fitness
    </TabsTrigger>
    <TabsTrigger value="performance" className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-center text-xs sm:text-sm whitespace-normal">
      <Gauge className="h-4 w-4" />
      Performance Insights
    </TabsTrigger>
    <TabsTrigger value="body" className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-center text-xs sm:text-sm whitespace-normal">
      <BarChart3 className="h-4 w-4" />
      Body Composition
    </TabsTrigger>
  </TabsList>

);
